import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridCell, GridToolbar, GridCellProps } from '@progress/kendo-react-grid';
import { fetchApi } from '../../services/api';
import ClassroomTabs from './Tabs';
import ChildrenCommandCell from './Children-Command-Cell';
import ChildAutoComplete from './ChildAutoComplete';

type Props = RouteComponentProps<{
    classroomId: string;
}>;

var PropsCopy: {
    classroomId: string;
};

type State = {
    classroomId: number;
    origchildren: Child[];
    children: Child[];
    isLoading: boolean;
}

export interface Child {
    ChildID: number;
    ChildName: string;
    FacilityID: number;
    FacilityName: string;
    RegisteredDate: Date;
    Birthday: Date;
    inEdit: boolean;
    Discontinued: boolean;
    [key: string]: any;
    AttendeeId: number;
}

export interface ChildSearchResult {
    ChildId: number;
    ChildName: string;
    FacilityName: string;
    Birthday: Date;
    FacilityId: number;
}

class ChildNameCell extends GridCell {
    myCallback = (dataFromChild: ChildSearchResult) => {
        this.props.dataItem.ChildID = dataFromChild.ChildId;
        this.props.dataItem.ChildName = dataFromChild.ChildName;
        this.props.dataItem.FacilityID = dataFromChild.FacilityId;
        this.props.dataItem.FacilityName = dataFromChild.FacilityName;
        this.props.dataItem.Birthday = dataFromChild.Birthday;
    };

    render() {
        if (this.props.dataItem.ChildName == null) {
            return (
                <td>
                    <ChildAutoComplete
                        style={{ color: '#007bff', width: '100%' }}
                        classroomId={parseInt(PropsCopy.classroomId)}
                        callbackFromParent={this.myCallback.bind(this)} />
                </td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={`/child/${this.props.dataItem.ChildID}`}>
                        {this.props.dataItem.ChildName}
                    </Link>
                </td>
            );
        }
    }
}

class FacilityNameCell extends GridCell {
    render() {
        if (this.props.dataItem.ChildName == null) {
            return (
                <td>-</td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={`/facility/${this.props.dataItem.FacilityID}`}>
                        {this.props.dataItem.FacilityName}
                    </Link>
                </td>
            );
        }
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field || this.props.dataItem.ChildName == null) {
            return <td>-</td>;
        }
        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).format("YYYY-MM-DD")}</td>
        );
    }
}

export default class ClassroomChildren extends React.Component<Props, State> {

    CommandCell: React.ComponentType<GridCellProps>;

    constructor(props: Props) {
        super(props);
        this.state = {
            classroomId: 0,
            children: [],
            origchildren: [],
            isLoading: false,
        };

        this.getChildren = this.getChildren.bind(this);

        this.enterInsert = this.enterInsert.bind(this);
        this.itemChange = this.itemChange.bind(this);

        //const enterEdit = this.enterEdit.bind(this);
        const save = this.save.bind(this);
        const cancel = this.cancel.bind(this);
        const remove = this.remove.bind(this);
        this.CommandCell = ChildrenCommandCell(null, remove, save, cancel, "inEdit");
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        //let classroomId = parseInt(this.props.match.params.classroomId) || 0;
        let classroomId = this.props.match.params.classroomId;
        PropsCopy = this.props.match.params;
        this.getChildren(parseInt(classroomId));
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        //let classroomId = parseInt(nextProps.match.params.classroomId) || 0;
        let classroomId = nextProps.match.params.classroomId;
        PropsCopy = this.props.match.params;
        if (this.state.children && this.state.classroomId != parseInt(classroomId)) {
            this.getChildren(parseInt(classroomId));
        }
    }

    public render() {
        return <div>
            <ClassroomTabs classroomId={this.state.classroomId} history={this.props.history} children />
            <br />
            <Grid data={this.state.children} editField="inEdit" onItemChange={this.itemChange}>
                <GridToolbar>
                    <button
                        title="Assign Child"
                        className="k-button k-primary"
                        onClick={this.enterInsert}
                    >Assign Child
                    </button>
                    {this.state.children.filter(p => p.inEdit).length > 0 && (
                        <button
                            title="Cancel current changes"
                            className="k-button"
                            onClick={(e) => this.setState({ children: this.state.origchildren.slice() })}
                        >Cancel current changes
                            </button>
                    )}
                </GridToolbar >
                <Column field="ChildName" title="Name" cell={ChildNameCell} />
                <Column field="FacilityName" title="Facility" cell={FacilityNameCell} />
                <Column field="Birthday" title="Birthday" cell={DateCell} filter="date" />
                <Column cell={this.CommandCell} width="180px" />
            </Grid>
        </div>;
    }

    enterInsert() {
        const dataItem = { inEdit: true, Discontinued: false };
        const newproducts = this.state.children.slice();
        newproducts.unshift(dataItem as Child);
        this.update(newproducts, dataItem as Child, false);
        this.setState({
            children: newproducts
        });
    }

    itemChange(event: any) {
        const value = event.value;
        let name = event.field;
        if (!name) {
            return;
        }
        const updatedData = this.state.children.slice();
        let item = this.update(updatedData, event.dataItem, false);
        item[name] = value;
        this.setState({
            children: updatedData
        });
    }

    //enterEdit(dataItem: Child) {
    //    this.update(this.state.children, dataItem, false).inEdit = true;
    //    this.setState({
    //        children: this.state.children.slice()
    //    });
    //}

    save(dataItem: Child) {
        dataItem.inEdit = false;
        //dataItem.ChildID = this.update(this.state.origchildren, dataItem as Child, false).ChildID;
        fetchApi(`api/Classrooms/SaveChild/${this.state.classroomId}`, dataItem, 'POST').then((response: any) => {
            dataItem.AttendeeId = response.AttendeeId as number;
            dataItem.ChildID = this.update(this.state.origchildren, dataItem as Child, false).ChildID;
            this.setState({
                children: this.state.children.slice()
            });
        });
    }

    cancel(dataItem: Child) {
        if (dataItem.ChildID && this.state.origchildren.length) {
            let originalItem = this.state.origchildren.find(p => p.ChildID === dataItem.ChildID);
            if (originalItem == null)
                this.update(this.state.children, dataItem, true);
            else
                this.update(this.state.children, originalItem as Child, false);
        } else {
            this.update(this.state.children, dataItem, true);
        }
        this.setState({
            children: this.state.children.slice()
        });
    }

    remove(dataItem: Child) {
        dataItem.inEdit = false;
        this.update(this.state.children, dataItem, true);
        this.update(this.state.origchildren, dataItem, true);

        fetchApi(`api/Classrooms/RemoveChild/${dataItem.AttendeeId}`, {}, 'DELETE').then(() => {
            this.setState({
                children: this.state.children.slice()
            });
        });
    }


    update(data: Child[], item: Child, remove: boolean) {
        let updated;
        let index = data.findIndex(p => p === item || item.ChildID != null && p.ChildID === item.ChildID);
        if (index >= 0) {
            updated = Object.assign({}, item);
            data[index] = updated;
        } else {
            updated = Object.assign({}, item);
            data.unshift(updated);
            index = 0;
        }

        if (remove) {
            data = data.splice(index, 1);
        }

        return data[index];
    }

    private getChildren(classroomId: number) {
        this.setState({ isLoading: true, classroomId });
        fetchApi(`api/Classrooms/Children/${classroomId}`)
            .then((children: Child[]) => {
                this.setState({ isLoading: false, children, origchildren: children });
            });
    }
}
